var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.noun = require("./noun");
company.descriptor = require("./descriptor");
company.adjective = require("./adjective");
company.bs_noun = require("./bs_noun");
company.bs_verb = require("./bs_verb");
company.bs_adjective = require("./bs_adjective");
company.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/company/index.js
// module id = 2432
// module chunks = 2